import disy from 'disy';
import disyCommons from 'disyCommons';
import $ from 'jquery';

// Wrapper around $.ajax() for requesting our REST endpoints
export default function (url, settings = {}) {
  return Promise.resolve($.ajax(apiUrl(url), settings).then(null, xhr => getProblem(xhr) || xhr));
}

// Assemble the full request URL from the given endpoint path
export function apiUrl (url) {
  return disyCommons.getUrl(`${disy.contextPath}/api${url}`);
}

function getProblem (xhr) {
  const problem = xhr.responseJSON;
  if (problem && problem.type && problem.type.startsWith('http://disy.net/problem/')) {
    return problem;
  }
}
